import { CreatePaymentRequestRequest } from '@payer-admin-ui/api/src/paymentrequests/requests/CreatePaymentRequestRequest';
import { GetPaymentRequestResponse } from '@payer-admin-ui/api/src/paymentrequests/responses/GetPaymentRequestResponse';
import { CreatePaymentRequestResponse } from '@payer-admin-ui/api/src/paymentrequests/responses/CreatePaymentRequestResponse';
import { PaymentRequestSendSmsRequest } from '@payer-admin-ui/api/src/paymentrequests/requests/PaymentRequestSendSmsRequest';
import { wrappedApiGet, wrappedApiPost } from '../utils/http';

export const paymentRequestAPI = {
  fetchById: async ({ id }: { id: string }): Promise<GetPaymentRequestResponse> => {
    return wrappedApiGet<GetPaymentRequestResponse>(`/payment-requests/${id}`).withObjectResponse();
  },

  createPaymentRequest: async (body: CreatePaymentRequestRequest): Promise<CreatePaymentRequestResponse> => {
    return wrappedApiPost<CreatePaymentRequestResponse>('/payment-requests', {
      body,
    }).withObjectResponse();
  },
  sendPaymentRequest: async ({ id, body }: { id: string; body: PaymentRequestSendSmsRequest }): Promise<void> => {
    return wrappedApiPost<void>(`/payment-requests/${id}/send`, {
      body,
    }).withEmptyResponse();
  },
};
